// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__SNG7L","mark":"Logo_mark__WfWT9","word":"Logo_word__-zaOK"};